export default __webpack_public_path__ + "static/media/competencias.67303b54.png";